import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Profile from './views/Profile.vue'
import View from './views/View.vue'
import Login from './views/Login.vue'
import Reset from './views/Reset.vue'
import Verify from './views/Verify.vue'
import Transactions from './views/Transactions.vue'
import Stripe from './views/Stripe.vue'
import BuyVr from './views/BuyVr.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/profile/:status',
      name: 'profile_key',
      component: Profile
    },
    {
      path: '/buy_vr/:device_id',
      name: 'buy_vr',
      component: BuyVr
    },
    {
      path: '/view/:device_id',
      name: 'view',
      component: View
    },
    {
      path: '/reset/:reset_token',
      name: 'reset',
      component: Reset
    },
    {
      path: '/client/verify/:verify_token',
      name: 'verify',
      component: Verify
    },
    {
      path: '/transactions',
      name: "transactions",
      component: Transactions
    },
    {
      path: '/api/stripe/charge/:status',
      name: "stripe",
      component: Stripe
    }
  ]
})